var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-852d60ce-e66c-4a84-a79e-b3e300b9744c",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-32701f9a-7bcc-4465-bb78-b42f418b0ead {\n        fill: #f2f2f2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-32701f9a-7bcc-4465-bb78-b42f418b0ead",
    d: "M20.16,9.04h-8.31c-1.54,0-2.8,1.26-2.8,2.8v8.31c0,1.54,1.26,2.8,2.8,2.8h8.31c1.54,0,2.8-1.26,2.8-2.8v-8.31c0-1.54-1.26-2.8-2.8-2.8ZM15.25,11.04h1.5v3.25h-1.5v-3.25ZM20.96,20.16c0,.44-.36.8-.8.8h-8.31c-.44,0-.8-.36-.8-.8v-8.31c0-.44.36-.8.8-.8h1.91v3.84c0,.5.41.91.91.91h2.69c.5,0,.91-.41.91-.91v-3.84h1.91c.44,0,.8.36.8.8v8.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPack);
export default __webpack_public_path__ + "static/media/Pack.5662e6971a0a34b6c081a7ff414c0a27.svg";
export { ForwardRef as ReactComponent };